import _ from 'underscore';
import Dexie from './dexie.service';

const Preference = Dexie.db.preferences;

class LocalPreferenceService {
    static async put(data) {
        if (_.isEmpty(data)) {
            return;
        }
        if (Array.isArray(data)) {
            return await Preference.bulkPut(data);
        }
        return await Preference.put(data);
    }

    static async getByKey(key, value) {
        if (!key || !value) {
            return [];
        }
        const data = await Preference.where(key).equals(value).toArray();
        return key === 'id' ? data.pop() : data;
    }

    static async update(id, changes) {
        if (_.isEmpty(changes)) {
            return;
        }
        return await Preference.update(id, changes);
    }
}

export default LocalPreferenceService;
